module.exports = __webpack_public_path__ + "img/Bergens-kapitelbok_Tegning-av-Anne-Pedersdotter-som-blir-brent.c3f3587d.jpg";